(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('googleMap', googleMap);

    /* @ngInject */
    function googleMap($q, $window, $sce) {
        var directive = {
            bindToController: true,
            templateUrl: 'google-map.tpl',
            controller: googleMapController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '=',
                locs: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var _isMobile,
                _mapSettings = scope.$root.globals.site_options.maps;
            if (!scope.$root.safeChain(_mapSettings,'api_key').trim()) {
                return console.error("Map API Key missing");
            }

            scope.vm.locations = [];
            scope.vm.activeLocation = {};
            scope.vm.searchText = null;
            scope.vm.showMobileInfoOverlay = false;

            if ($window.matchMedia) {
                var mql = $window.matchMedia('only screen and (max-width: 767px)');
                _isMobile = mql.matches;
                mql.addListener(function(mql) {
                    _isMobile = mql.matches;
                });
            }

            scope.vm.resetSearch = function(event) {
                event.stopPropagation();
                scope.vm.searchText = '';
                scope.resetMarkers();
            };

            scope.safeApply = function(fn) {
                var phase = this.$root.$$phase;
                if(phase == '$apply' || phase == '$digest') {
                    if(fn) {
                        fn();
                    }
                } else {
                    this.$apply(fn);
                }
            };

            scope.vm.getHours = function(params, ends) {
                var output = scope.$root.formatHours(params, ends);
                return $sce.trustAsHtml(output === '' ? '' : output);
            };

            function openMobileInfoOverlay() {
                if (_isMobile === false) { return; }
                scope.vm.showMobileInfoOverlay = true;
                scope.safeApply();
            }


            function attachMarkerClickEvent(marker) {
                marker.addListener('click', function() {
                    scope.$emit("location-changed", {
                        id: marker.loc.data.id,
                        dt: marker.loc.data.dt,
                        title: marker.loc.data.title,
                        'site-no': marker.loc.data['site-no'],
                        address: marker.loc.data.address,
                        hours: scope.vm.getHours(marker.loc.data['pick-up-hours']),
                        hoursRaw: marker.loc.data['pick-up-hours']
                    });


                    scope.vm.activeLocation.id = marker.loc.data.id;
                    scope.setActiveMarker();
                    scope.safeApply();
                    scope.toolTip.close();
                    scope.toolTip.setContent(
                        '<div class="google-tooltip">' +
                            '<p class="city">' + marker.loc.data.title + ', ' + '</p>' +
                            '<p class="address">' + marker.loc.data.address + '</p>' +
                            '<hr style="margin: 0.375rem 0;">' +
                            '<p class="hours">' + '<strong>' + scope.vm.getHours(marker.loc.data['pick-up-hours'], true) + '</strong>' + '</p>' +
                        '</div>'
                    );
                    scope.toolTip.open(scope.map, marker);
                    openMobileInfoOverlay();

                });

                // marker.addListener('mouseover', function() {
                //     scope.vm.activeLocation.id = marker.loc.data.id;
                //     scope.setActiveMarker();
                //     scope.safeApply();
                //     scope.toolTip.close();
                //     var isInventory = (marker.loc.data.inventory && (marker.loc.data.inventory.length > 0));
                //     var ttContent = '<div class="google-tooltip">' +
                //             (isInventory ? '<p class="limits">Quantities are limited. See available pies below.</p>' : '') +
                //             '<p class="city">' + marker.loc.data.title + ', ' + '</p>' +
                //             '<p class="address">' + marker.loc.data.address + '</p>' +
                //             '<hr style="margin: 0.375rem 0;">' +
                //             '<p class="hours">' + '<strong>' + scope.vm.getHours(marker.loc.data['pick-up-hours'], true) + '</strong>' + '</p>';
                //     if (isInventory) {
                //         ttContent += '<hr style="margin: 0.3rem 0;">' +
                //         '<p class="si-title"><strong>Site Inventory</strong></p>';
                //         marker.loc.data.inventory.forEach(function(e) {
                //             ttContent += '<p class="quantities">' +  e.name + ': ' + (e.inStock == 0 ? 'Sold Out' : e.inStock + ' available') + '</p>';
                //         });
                //     }
                //     ttContent += '</div>';
                //     scope.toolTip.setContent(ttContent);
                //     scope.toolTip.open(scope.map, marker);
                //     openMobileInfoOverlay();
                // });

                marker.addListener('mouseover', function() {
                    scope.vm.activeLocation.id = marker.loc.data.id;
                    scope.setActiveMarker();
                    scope.safeApply();
                    scope.toolTip.close();
                    var isInventory = (marker.loc.data.inventory && (marker.loc.data.inventory.length > 0));
                    var ttContent =  (isInventory ? '<p class="limits">Quantities are limited. See available pies below.</p>' : '') +
                            '<p class="city">' + marker.loc.data.title + ', ' + '</p>' +
                            '<p class="address">' + marker.loc.data.address + '</p>' +
                            '<hr style="margin: 0.375rem 0;">' +
                            '<p class="hours">' + '<strong>' + scope.vm.getHours(marker.loc.data['pick-up-hours'], true) + '</strong>' + '</p>';
                    if (isInventory) {
                        ttContent += '<hr style="margin: 0.3rem 0;">' +
                        '<p class="si-title"><strong>Site Inventory</strong></p>';
                        marker.loc.data.inventory.forEach(function(e) {
                            ttContent += '<p class="quantities">' +  e.name + ': ' + (e.inStock == 0 ? 'Sold Out' : e.inStock + ' available') + '</p>';
                        });
                    }
                    var tt = Object.assign(document.createElement('div'), {
                        innerHTML: ttContent,
                        className:  'google-tooltip'
                    });
                    tt.addEventListener('click', function() {
                        new google.maps.event.trigger(marker, 'click');
                    });
                    scope.toolTip.setContent(tt);
                    scope.toolTip.open(scope.map, marker);
                    openMobileInfoOverlay();
                });

            }

            function parseLocations(locs) {
                for (var i = 0; i < locs.length; i++) {
                    if (!locs[i].lat || !locs[i].lng) {
                        continue;
                    }

                    if (!locs[i].inventory && scope.$root.project_has_opt('siteInventory')) {
                        continue;
                    }

                    var LatLng = {lat: locs[i].lat, lng:locs[i].lng};
                    var marker = new google.maps.Marker({
                        map: scope.map,
                        position: LatLng,
                        icon: scope.vm_pinActive,
                        loc: {data: locs[i]}
                    });

                    attachMarkerClickEvent(marker);
                    var l = {
                        title:locs[i].title ,
                        data : locs[i],
                        marker: marker,
                        show: !locs[i].private || locs[i].id == scope.vm.data.value
                    };
                    scope.vm.locations.push(l);
                }
            }

            function initializeMap() {

                var mapStyle = [{
                    'stylers': [{ 'saturation': -100 }, { 'gamma': 1 }]
                }, {
                    'elementType':'labels.text.stroke',
                    'stylers':[{ 'visibility': 'off' }]
                }, {
                    'featureType':'road',
                    'elementType':'geometry',
                    'stylers':[{ 'visibility': 'simplified' }]
                }];
                scope.vm._defaultZoom = 10;
                if (!_mapSettings.default_location.lat || !_mapSettings.default_location.lng) {
                    _mapSettings.default_location = {
                        address: _mapSettings.default_location,
                        lat: 0,
                        lng: 0
                    };
                }
                scope.vm._defaultCenter = new google.maps.LatLng(parseFloat(_mapSettings.default_location.lat), parseFloat(_mapSettings.default_location.lng));
                scope.vm._pinActive = {
                    url: '/wp-content/themes/pie/img/icons/pin-' + scope.$root.globals.site_options.project_slug +  '.png',
                    size: new google.maps.Size(37, 33),
                    scaledSize: new google.maps.Size(37, 33),
                    anchor: new google.maps.Point(12, 33)
                };

                scope.vm._pinGrey = {
                    url: '/wp-content/themes/pie/img/icons/pin-grey.png',
                    size: new google.maps.Size(37, 33),
                    scaledSize: new google.maps.Size(37, 33),
                    anchor: new google.maps.Point(12, 33)
                };

                var mapOptions = {
                    zoom: scope.vm._defaultZoom,
                    center: scope.vm._defaultCenter,
                    styles: mapStyle,
                    disableDefaultUI: true,
                    mapTypeControl: false,
                    zoomControl: true,
                    scrollwheel: false,
                    gestureHandling: 'greedy',
                    mapTypeControlOptions: {
                        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
                        mapTypeIds: ['roadmap', 'terrain']
                    }
                };
                scope.map =  new google.maps.Map(document.getElementById('map-container'), mapOptions);
                scope.toolTip =  new google.maps.InfoWindow({
                    content: '',
                    maxWidth: 220
                });
            }

            function start () {
                setTimeout(function() {
                    initializeMap();
                    if (scope.vm.locations.length == 0) {
                        parseLocations(scope.vm.locs);
                    }
                    scope.resetMarkers();
                }, scope.$root.project_has_opt('scWizard') ? 10 : 2000);
            }

            if ((typeof google == 'undefined') || (typeof google.maps == 'undefined')) {
                scope.$root.loadGoogleMap(function() {
                    start();
                });
            } else {
                start();
            }
        }
    }

    /* @ngInject */
    function googleMapController ($scope, $http) {
        $scope.setActiveMarker = function () {
            $scope.vm.locations.forEach(function(l) {
                if (l.data.id !== $scope.vm.activeLocation.id) {
                    l.marker.setIcon($scope.vm._pinGrey);
                } else {
                    l.marker.setIcon($scope.vm._pinActive);
                }
            });
        };

        $scope.$watch('vm.searchText', function(value) {
            $scope.resetMarkers();
        });

        $scope.searchFilter = function(data) {
            if (!$scope.vm.searchText) {
                return true;
            }

            var queryLower = $scope.vm.searchText.toLocaleLowerCase().trim();
            return (
                (data['site-no'].indexOf(queryLower) !== -1) || (data.city.toLocaleLowerCase().indexOf(queryLower) !== -1) ||
                (data.title.toLocaleLowerCase().indexOf(queryLower) !== -1) ||
                ((/\d+/).test(queryLower) && (data.address.indexOf(queryLower) !== -1)) ||
                (data.address.toLocaleLowerCase().indexOf(queryLower) !== -1)
            );
        };


        $scope.frameByZip = function(zip) {
            function distance(p1, p2) {
                var R = 3958.8;
                var rlat1 = p1.lat * (Math.PI / 180);
                var rlat2 = p2.lat * (Math.PI / 180);
                var difflat = rlat2 - rlat1;
                var difflng = (p2.lng - p1.lng) * (Math.PI / 180);
                return 2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflng / 2) * Math.sin(difflng / 2)));
            }

            $http.post(ajaxurl, {
                action: 'pie_action',
                method: 'get_bounds',
                nonce: $scope.$root.stats.nonce,
                params: {
                    zip: zip
                }
            }).then(function(response) {
                if (response.data.result) {
                    var location = response.data.payload.location;
                    var bounds = new google.maps.LatLngBounds();
                    var found = false;
                    if (typeof $scope.vm.zipCenter == 'object') {
                        $scope.vm.zipCenter.setMap(null);
                    }
                    $scope.vm.locations.forEach(function(e) {
                        var d = distance(location, {lat: e.data.lat, lng: e.data.lng});
                        if (d <= 10) {
                            found = true;
                            e.marker.setVisible(true);
                            e.marker.setIcon($scope.vm._pinActive);
                            bounds.extend({lat: e.data.lat, lng: e.data.lng});
                        }
                    });
                    if (!found) {
                        $scope.vm.searchText = '';
                    } else {
                        $scope.map.fitBounds(bounds);
                    }
                    // if (found) {
                    //     bounds.extend(location);
                    //     $scope.map.fitBounds(bounds);
                    //     $scope.vm.zipCenter  = new google.maps.Circle({
                    //         strokeColor: "#e35928",
                    //         strokeOpacity: 0.8,
                    //         strokeWeight: 2,
                    //         fillColor: "#e35928",
                    //         fillOpacity: 0.35,
                    //         center: location,
                    //         radius: 2000,
                    //         map: $scope.map
                    //     });
                    // }
                } else {
                    console.log(response.data.message);
                    $scope.vm.searchText = '';
                }
            });
        };

        $scope.resetMarkers = function() {
            if (!$scope.map) {
                return;
            }
            if (typeof $scope.vm.zipCenter == 'object') {
                $scope.vm.zipCenter.setMap(null);
            }
            var filtered = [];
            if ($scope.toolTip) {
                $scope.toolTip.close();
            }
            $scope.vm.locations.forEach(function(l) {
                l.marker.setVisible(false);
                if (l.show && $scope.searchFilter(l.data)) {
                    filtered.push(l);
                }
            });
            if(filtered.length === 0) {
                if ($scope.$root.project_has_opt('zipGeodata')) {
                    if ($scope.vm.searchText) {
                        var v  = $scope.vm.searchText.toLocaleLowerCase().trim();
                        if (/^\d{5}$/.test(v)) {
                            console.log('geolocation');
                            $scope.frameByZip(v);
                            return;
                        }
                    }
                }
                $scope.map.setCenter($scope.vm._defaultCenter);
                $scope.map.setZoom($scope.vm._defaultZoom);
            } else if (filtered.length === 1) {
                var m = filtered[0].marker;
                m.setVisible(true);
                m.setIcon($scope.vm._pinActive);
                $scope.map.setCenter(m.getPosition());
            } else {
                var bounds = new google.maps.LatLngBounds();
                filtered.forEach(function(fl) {
                    fl.marker.setVisible(true);
                    fl.marker.setIcon($scope.vm._pinActive);
                    bounds.extend(fl.marker.position);
                });
                $scope.map.fitBounds(bounds);
            }
        };
        $scope.$on('accordion-tab', function(e, d) {
            if (d == 'site') {
                setTimeout(function() {
                    $scope.activateLocation(true);
                }, 10);
            }
        });
        $scope.$on('pickup-location-changed-external', function(e, reset) {
            $scope.activateLocation(reset);
        });
        $scope.$on('map-tab', function(e) {
            setTimeout(function() {
                $scope.activateLocation(false);
            }, 100);
        });

        $scope.activateLocation = function(reset) {
            $scope.searchText = '';
            if (reset) {
                $scope.vm.locations.forEach(function(e) {
                    e.show =  !e.data.private;
                });
            }
            if ($scope.toolTip) {
                $scope.toolTip.close();
            }

            if ($scope.vm.data.value) {
                var l = $scope.vm.locations.find(function(e) {
                    return e.data.id ==  $scope.vm.data.value;
                });
                if (l) {
                    l.show = true;
                    $scope.resetMarkers();
                    $scope.vm.activeLocation.id = l.data.id;
                    $scope.setActiveMarker();
                } else {
                    $scope.vm.activeLocation.id = null;
                    $scope.resetMarkers();
                }
            } else {
                $scope.resetMarkers();
            }
        };

        // $scope.$on('site-inventory-filter', function(e, pies) {
        //     var poor = 0;
        //     var noSites = (((Object.values(pies).length == 1)  && (Object.values(pies)[0]['short-name'] == 'PFC')) || (Object.values(pies).length == 0)) ? true : false;
        //     $scope.vm.locations.forEach(function(l) {
        //         var active = true;
        //         if (l.data.inventory) {
        //             l.data.inventory.forEach(function(e) {
        //                 if (pies[e.pie_id.value] && (pies[e.pie_id.value].value > e.inStock)) {
        //                     active = false;
        //                     return;
        //                 }
        //             });
        //         }
        //         if (active) {
        //             l.marker.setIcon($scope.vm._pinOrange);
        //         } else {
        //             poor++;
        //             l.marker.setIcon($scope.vm._pinGrey);
        //         }
        //     });
        //     console.log('site-inventory-filter', poor, $scope.vm.locations.length);

        //     if ((poor == $scope.vm.locations.length) || noSites) {
        //         if (angular.element('[field-key="site"] > div').hasClass('active')) {
        //             setTimeout(function() {
        //                 angular.element('[field-key="site"] button.accordion-toggle').click();
        //                 $scope.$root.blockTab = 'site';
        //             }, 10);
        //         } else {
        //             $scope.$root.blockTab = 'site';
        //         }
        //         console.log('poor, noSites', poor, noSites);
        //         $scope.$emit('location-changed', null);
        //     } else {
        //         $scope.$root.blockTab = '';
        //     }
        // });
    }
})();